<template>
  <div class="block md:grid gap-x-lg grid-cols-pageWide mb-4">
    <h3 id="payment-methods-title" class="mb-none col-span-full">{{ $t('companySettings.billing.paymentMethodsSection.title') }}</h3>
    <hr class="my-base col-span-full" />
    <div class="col-span-1 mb-base">
      <p id="payment-methods-info1">{{ $t('companySettings.billing.paymentMethodsSection.info1') }}</p>
      <p id="payment-methods-info2">{{ $t('companySettings.billing.paymentMethodsSection.info2') }}</p>
    </div>
    <div class="col-span-1 mb-base">
      <div v-if="paymentMethods.length" id="payment-methods-method-list">
        <BillingPaymentMethod
            v-for="(method, index) in paymentMethods"
            :key="index"
            :method="method"
            v-on:openSwitchModal="openSelectDefaultPaymentMethodModal(method.id)"
            v-on:openDeleteModal="openRemovePaymentMethodModal(method.id)" />
      </div>
      <div class="col-span-1 mb-base" v-else>
        <VMessage
          id="payment-methods-no-methods-warning"
          type="warning"
          subtype="outlined"
          :fullwidth="true">
          <template v-slot:icon>
            <ExclamationTriangleIcon />
          </template>
          <template v-slot:text>
            {{ $t('companySettings.billing.paymentMethodsSection.noMethods') }}
          </template>
        </VMessage>
      </div>
      <div class="inline-block">
        <VButton
            type="outline-1"
            @click.native="showPaymentMethodModal = true;"
            data-ec="billing_payment_methods"
            data-et="add_payment_method_button">
          {{ $t('companySettings.billing.paymentMethods.addPaymentMethod') }}
        </VButton>
      </div>
    </div>

    <AddPaymentMethodModal :show="showPaymentMethodModal" dd-scope="paymentMethodsDD" @close="showPaymentMethodModal = false;" />
    <SelectDefaultPaymentMethodModal :paymentMethodId="selectedPaymentMethodId" :show="showSwitchMethodModal" @close="showSwitchMethodModal = false;" />
    <VDynamicLoader
        viewURL="modals/payment/RemovePaymentMethodModal"
        :data="{
        method: selectedPaymentMethodId,
      }" />
  </div>
</template>

<script>

import VButton from '@/components/deprecated/atoms/Button.vue';
import VMessage from '@/components/deprecated/atoms/Message.vue';
import AddPaymentMethodModal from '@/views/modals/payment/AddPaymentMethodModal.vue';
import SelectDefaultPaymentMethodModal from '@/views/modals/payment/SelectDefaultPaymentMethodModal.vue';
import BillingPaymentMethod from '@/views/components/billing/PaymentMethod.vue';
import VDynamicLoader from '@/components/DynamicLoader.vue';
import { ExclamationTriangleIcon } from '@/components/icons/fontIcons';

export default {
  name: 'BillingPaymentMethods',
  components: {
    VMessage,
    BillingPaymentMethod,
    VButton,
    AddPaymentMethodModal,
    SelectDefaultPaymentMethodModal,
    VDynamicLoader,
    ExclamationTriangleIcon,
  },
  data() {
    return {
      showPaymentMethodModal: false,
      showSwitchMethodModal: false,
      selectedPaymentMethodId: '',
    };
  },
  props: {
    paymentMethods: Array,
  },
  methods: {
    openRemovePaymentMethodModal(id) {
      this.selectedPaymentMethodId = id;
      this.$bus.$emit('toggleModal', { name: 'remove-payment-method-modal', active: true });
    },
    openSelectDefaultPaymentMethodModal(id) {
      this.selectedPaymentMethodId = id;
      this.showSwitchMethodModal = true;
    },
  },
};

</script>
